<script lang="ts">
    import FormVehicle from "../FormVehicle.svelte";
    import {IMaintenance} from "../../data";
    import PrepaidMaintenancePage from "./PrepaidMaintenancePage.svelte";
    import {onMount} from "svelte";

    export let maintenance: IMaintenance;
    export let cities: Array<any> = [];
    export let plans = {};
    export let error: string = null;
    export let km: number;

    export let keys = {
        silver: {
            description: 'descSilver',
            precioTotal: 'precioSilverTotal',
            precioNeto: 'precioSilverNeto',
            porcDescuento: 'porcDescuentoSilver',
            vin: 'vin',
            codModeloTasa: 'codModeloTasa',
            ciudad: 'ciudad',
        },
        gold: {
            description: 'descGold',
            precioTotal: 'precioGoldTotal',
            precioNeto: 'precioGoldNeto',
            porcDescuento: 'porcDescuentoGold',
            vin: 'vin',
            codModeloTasa: 'codModeloTasa',
            ciudad: 'ciudad',
        }
    };

    export let info_silver = {};
    export let info_gold = {};

    export let detailCmpt: any;

    // Usada en la plantilla de jinja2
    export function getInfo() {
        info_silver = {};
        info_gold = {};
        Object.keys(keys["silver"]).forEach((k) => {
            info_silver[k] = maintenance[keys["silver"][k]];
        });
        Object.keys(keys["gold"]).forEach((k) => {
            info_gold[k] = maintenance[keys["gold"][k]];
        });

        return {
            silver: info_silver,
            gold: info_gold
        }

    }

    async function showDetail(km) {
        const details = await fetch(`/backend/api/v2/ecommerce/mantenimiento-prepagado-revision/kilometros/${km}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(r => r.json());
        detailCmpt.$set({
            open: true,
            details
        });
    }

    const tabs = [
        {label: 'Gold', slug: 'gold'},
        {label: 'Silver', slug: 'silver'},
    ];
    let activeTab = 'gold';

    onMount(() => {
        if (activeTab !== '') {
            activeTab = tabs[0].slug;
        }
    });

    const isMobile = window.innerWidth < 768;
</script>

<section>
    {#if !maintenance}
    <div class="container py-15">
        {#if isMobile}
            <img class="w-100" src="/static/storefront/pix/banner-mant-prepagado-mobile.jpg" alt="Mantenimiento prepagado">
        {:else}
            <img class="w-100 max-w-1200px mx-auto" src="/static/storefront/pix/banner-mant-prepagado-desktop.jpg" alt="Mantenimiento prepagado">
        {/if}
        <FormVehicle title="Conoce los detalles del plan ideal para tu Nissan"
                     button="Detalles de mi plan"
                     {cities}
                     on:search
                     {error}
                     formStyle="field-inline"/>
        <div class="w-100 max-w-900px mx-auto">
            Mantenimiento prepagado es un plan de mantenimiento con el que puedes vivir tranquilo, adquiriendo
            anticipadamente 4 o 6 revisiones de mantenimiento preventivo para tu vehiculo Nissan.
        </div>
    </div>
    {/if}
    {#if isMobile}
        {#if maintenance}
            <div class="tabs w-100 border-bottom box-l sx-1">
                {#each tabs as tab (tab.slug)}
                    <div class="pointer tab block py-iii px-1 text-c" style="min-width: 50%;"
                         class:active={activeTab === tab.slug}
                         on:click={()=> activeTab = tab.slug}>
                        {tab.label}
                    </div>
                {/each}
            </div>
        {/if}
        <div style="display: flex; width: 100%">
            <div style="{activeTab === 'gold' ? 'display: block;' : 'display: none'}; width: 100%">
                <PrepaidMaintenancePage {km} {maintenance} {showDetail} price={info_gold} plan={plans.gold} wp_link="https://bit.ly/39es3sU"/>
            </div>
            <div style="{activeTab === 'silver' ? 'display: block;' : 'display: none'}; width: 100%">
                <PrepaidMaintenancePage {km} {maintenance} {showDetail} price={info_silver} plan={plans.silver} wp_link="https://bit.ly/37ATfBM"/>
            </div>
        </div>
    {:else}
        <div style="display: flex; width: 100%">
            <div style="float: left; width: 50%">
                <PrepaidMaintenancePage {km} {maintenance} {showDetail} price={info_gold} plan={plans.gold} wp_link="https://bit.ly/39es3sU"/>
            </div>
            <div style="float: left; width: 50%">
                <PrepaidMaintenancePage {km} {maintenance} {showDetail} price={info_silver} plan={plans.silver} wp_link="https://bit.ly/37ATfBM"/>
            </div>
        </div>
    {/if}


</section>

<style>
    .active {
        background-color: #ccc;
    }
</style>
